import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from './apis';
import Swal from 'sweetalert2';

export const getAllProperties = createAsyncThunk(
  'Properties/getAllProperties',
  async ({ filter, pagination = null }: any) => {
    try {
      const res: any = await API.getAllProperties({ filter, pagination });
      return res.data;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);

export const updateProperty = createAsyncThunk(
  'Properties/updateProperty',
  async ({ values, text }: any) => {
    try {
      const res = await API.updateProperty(values);
      Swal.fire({
        icon: 'success',
        title: `${text || 'Editado'} con exito`,
      });
      return res;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: `Hubo un error al editar los datos`,
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);

export const createProperty = createAsyncThunk(
  'Properties/createProperty',
  async (property: any) => {
    try {
      const res = await API.createProperty(property);
      if (res.status === 200) {
        Swal.fire(
          'Correcto',
          'La propiedad se agregó correctamente',
          'success'
        );
        return true;
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al crear la propiedad',
        text: 'Por favor, intenta de nuevo',
      });
      throw error;
    }
  }
);

export const getProblems = createAsyncThunk(
  'Properties/getProblems',
  async () => {
    try {
      const res = await API.getProblems();
      return res.data.problems || [];
    } catch (error) {
      throw error;
    }
  }
);
